"use client"

const ErrorNotification = ({ error, setError }) => {
  if (!error) return null

  return (
    <div className="error-notification">
      <p>{error}</p>
      <button onClick={() => setError("")} className="close-error-btn">
        ×
      </button>
    </div>
  )
}

export default ErrorNotification
